import { SVGProps } from "react";

export default function MinusCircleIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#D44333", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.9349 18.3333C14.5182 18.3333 18.2682 14.5833 18.2682 10C18.2682 5.41666 14.5182 1.66666 9.9349 1.66666C5.35156 1.66666 1.60156 5.41666 1.60156 10C1.60156 14.5833 5.35156 18.3333 9.9349 18.3333Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.60156 10H13.2682"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
